import * as React from "react";
import { Box, Button, Menu, MenuItem, Typography } from "@mui/material";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const LATAM_COUNTRIES = [
    "All countries",
    "Argentina",
    "Belize",
    "Bolivia",
    "Brazil",
    "Chile",
    "Colombia",
    "Costa Rica",
    "Cuba",
    "Dominican Republic",
    "Ecuador",
    "El Salvador",
    "Guatemala",
    "Haiti",
    "Honduras",
    "Jamaica",
    "Mexico",
    "Nicaragua",
    "Panama",
    "Paraguay",
    "Peru",
    "Trinidad and Tobago",
    "Uruguay",
    "Venezuela",
];

export function CountrySelectLatAm({
    value,
    onChange,        // 👈 importante
    placeholder = "Choose a country",
    sx,
}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleSelect = (countryName) => {
        onChange?.(countryName);   // 🔥 envía al padre
        handleClose();
    };

    const hasValue = Boolean(value);
    const label = hasValue ? value : placeholder;

    return (
        <Box sx={{ width: "100%", ...sx }}>
            <Button
                fullWidth
                disableRipple
                onClick={handleOpen}
                endIcon={<KeyboardArrowDownRoundedIcon />}
                sx={{
                    justifyContent: "space-between",
                    textTransform: "none",
                    color: hasValue ? "text.primary" : "text.secondary",
                    fontWeight: hasValue ? 500 : 400,
                    px: 2,
                    py: 1.25,
                    minHeight: 44,
                    borderTop: "1px solid #222",
                    borderBottom: "1px solid #222",
                    borderRadius: 0,
                    "&:hover": { bgcolor: "transparent" },
                    "&:focus-visible": { outline: "none" },
                }}
            >
                <Typography variant="body1">
                    {label}
                </Typography>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}

                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                MenuListProps={{ dense: true, sx: { py: 1 } }}
                PaperProps={{
                    elevation: 0,
                    sx: {
                        mt: 0,
                        borderTop: "1px solid #222",
                        borderBottom: "1px solid #222",
                        borderRadius: 0,
                        boxShadow: "none",
                        width: '100%',
                        maxWidth: '560px',
                        maxHeight: 320,
                        overflowY: "auto",
                    },
                }}
            >
                {LATAM_COUNTRIES.map((opt) => (
                    <MenuItem
                        key={opt}
                        onClick={() => handleSelect(opt)}
                        selected={opt === value}

                        sx={{
                            px: 2,
                            py: 1,
                            fontWeight: opt === value ? 700 : 400,
                        }}
                    >
                        <Typography variant="body1">
                            {opt}
                        </Typography>
                    </MenuItem>
                ))}
            </Menu>

        </Box>
    );
}
